import React, { Component, PropTypes } from 'react'

export class QuadColumn extends Component {
  render() {
    return (
      <section>
        <div className="container">
          <div className="section__head--noPara">
            <h2>Program Benefits</h2>
          </div>
          <div className="section__body">
            <div className="row">
              <div className="column--fourth">
                <div className="card">
                  <div className="meta">
                    <h4>Tournament Engine</h4>
                    <p>
                      A season pass covers all match scheduling, tournament brackets, playoffs and the State
                      Championship.
                    </p>
                  </div>
                </div>
              </div>
              <div className="column--fourth">
                <div className="card">
                  <div className="meta">
                    <h4>Game Partnerships</h4>
                    <p>
                      We partner directly with publishers to create a seamless experience for coaches and
                      players.
                    </p>
                  </div>
                </div>
              </div>
              <div className="column--fourth">
                <div className="card">
                  <div className="meta">
                    <h4>Resources</h4>
                    <p>
                      PlayVS provides playbooks, guides and clinics for players and coaches to level up their
                      gameplay.
                    </p>
                  </div>
                </div>
              </div>
              <div className="column--fourth">
                <div className="card">
                  <div className="meta">
                    <h4>Stats & Highlights</h4>
                    <p>
                      Accessible stats and highlights help coaches align strategies to improve overall team
                      performance.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    )
  }
}

export default QuadColumn



// WEBPACK FOOTER //
// ./src/common/ui/components/quadColumn__benefits.js